export default __webpack_public_path__ + "static/media/bgShop.10361a31.png";